/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-subject': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M1.883 16A1.882 1.882 0 010 14.118h16A1.882 1.882 0 0114.117 16zM16 13.177h-4.324V6.706a2 2 0 012-2H14a2 2 0 012 2v6.47zm-3.459-3.765a.471.471 0 00.471.471h1.653a.471.471 0 100-.941h-1.654a.471.471 0 00-.47.47zm0-2.353a.471.471 0 00.471.471h1.653a.47.47 0 100-.941h-1.654a.47.47 0 00-.47.47zm-2.164 6.118h-5.62V2a2 2 0 012-2h1.621a2 2 0 012 2v11.176zM5.693 7.6a.508.508 0 00.507.507h2.734a.507.507 0 000-1.013H6.2a.508.508 0 00-.507.506zm0-2.028a.508.508 0 00.507.508h2.734a.507.507 0 000-1.014H6.2a.508.508 0 00-.507.509zm0-2.027a.508.508 0 00.507.507h2.734a.507.507 0 000-1.013H6.2a.508.508 0 00-.507.509zM0 13.177V5.711a1.946 1.946 0 013.892 0v7.466z" _fill="#212121"/>'
  }
})
